import { render, staticRenderFns } from "./Leilao.vue?vue&type=template&id=5a7a9e6a"
import script from "./Leilao.vue?vue&type=script&lang=js"
export * from "./Leilao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports